import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonText", "buttonUse", "options"],
  _excluded2 = ["buttonText", "buttonUse", "subMenuName"];
import { usePublicCatalogFilters } from '../publicCatalogQueries';
import UIMultiLevelDropdown from 'UIComponents/dropdown/UIMultiLevelDropdown';
import UILoadingDots from 'UIComponents/loading/UILoadingDots';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useGetFilterOptions, useGetSubMenu } from '../publicCatalogDropdownHooks';
import styled from 'academy-common-lib/utils/Styling';
import { NavMarker } from 'react-rhumb';
import { getFilterNameFromSubMenuName } from '../publicCatalogDropdownUtils';
import { subMenuNamesAndOptions } from '../publicCatalogDropdownConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownContainer = styled.div.withConfig({
  displayName: "PublicCatalogDropdown__DropdownContainer",
  componentId: "sc-1pqfbpb-0"
})(["display:inline;color:white;.public-catalog-dropdown-button{height:", ";}"], ({
  $isLink
}) => $isLink ? 'auto' : '60px');
const loadingOption = {
  label: /*#__PURE__*/_jsx(UILoadingDots, {}),
  style: {
    pointerEvents: 'none'
  }
};
const errorOption = {
  label: /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.catalogPage.filters.filtersLoadError"
    }), ' ', /*#__PURE__*/_jsx(UIIcon, {
      name: "refresh"
    })]
  }),
  onClick: () => window.location.reload()
};
const Dropdown = _ref => {
  let {
      buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.browseCatalog"
      }),
      buttonUse = 'tertiary-light',
      options
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DropdownContainer, {
    $isLink: buttonUse.includes('link'),
    children: /*#__PURE__*/_jsx(UIMultiLevelDropdown, Object.assign({
      autoPlacement: false,
      buttonClassName: "public-catalog-dropdown-button",
      buttonText: buttonText,
      buttonUse: buttonUse,
      minMenuWidth: 250,
      options: options,
      placement: "bottom"
    }, rest))
  });
};
const PublicCatalogDropdown = _ref2 => {
  let {
      buttonText,
      buttonUse,
      subMenuName
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    filtersData,
    filtersError,
    filtersLoading
  } = usePublicCatalogFilters();
  const getFilterOptions = useGetFilterOptions();
  const getSubMenu = useGetSubMenu();
  if (filtersLoading) {
    return /*#__PURE__*/_jsx(Dropdown, Object.assign({
      buttonText: buttonText,
      buttonUse: buttonUse,
      "data-test-id": "loadingDropdown",
      options: [loadingOption]
    }, rest));
  }
  if (filtersError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "CATALOG_FILTERS_LOAD_FAILURE",
      children: /*#__PURE__*/_jsx(Dropdown, Object.assign({
        buttonText: buttonText,
        buttonUse: buttonUse,
        "data-test-id": "errorDropdown",
        options: [errorOption]
      }, rest))
    });
  }
  let dropdownOptions = [];
  if (!subMenuName) {
    //render all options and submenus (primary menu)
    const getCategoryGroup = () => getFilterOptions('cat', filtersData.subCategories);
    const getToolsGroup = () => getFilterOptions('tools', filtersData.hsSoftwareFilters);
    dropdownOptions = [...getCategoryGroup(), ...getToolsGroup()];
  } else {
    // render submenu only
    const filterName = getFilterNameFromSubMenuName(subMenuName);
    if (!filterName) return null;
    dropdownOptions = getSubMenu(filterName, subMenuName,
    // @ts-expect-error subMenuName can index this object
    subMenuNamesAndOptions[filterName][subMenuName]).options;
  }
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    buttonText: buttonText,
    buttonUse: buttonUse,
    options: dropdownOptions
  }, rest));
};
export default PublicCatalogDropdown;